import React, { useState } from 'react';
import SEO from "../component/SEO";
import loginSignupImage from '../images/icon.gif';
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-hot-toast";
import { useDispatch } from 'react-redux';
import { setToken } from '../redux/userSlice';
import Cookies from 'js-cookie';
import { GoogleLogin } from '@react-oauth/google';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { FaFacebookF } from 'react-icons/fa';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({
      email: "",
      password: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleShowPassword = () => {
      setShowPassword(prev => !prev);
  }

  const handleOnChange = (e) => {
      const { name, value } = e.target;
      setData(prev => ({ ...prev, [name]: value }));
  }

  const handleSubmit = async (e) => {
      e.preventDefault();
      const { email, password } = data;

      if (!email || !password) {
          return toast.error("Please enter required fields");
      }

      try {
          const fetchData = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/login`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email, password })
          });

          const ObjectRes = await fetchData.json();
          const dataRes = ObjectRes;

          if (dataRes.alert) {
              toast.success(dataRes.message);
          } else {
              toast.error(dataRes.message);
              if (dataRes.message.includes("verify your email")) {
                  setTimeout(() => {
                      navigate("/verify-email", { state: { email } });
                  }, 1500);
                  return;
              }
          }

          if (dataRes.alert && dataRes.token) {
              // Fetch admin status from backend
              const adminRes = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/is-admin`, {
                  headers: { Authorization: `Bearer ${dataRes.token}` },
              });
              const { isAdmin } = await adminRes.json();

              const userData = {
                  token: dataRes.token,
                  email: dataRes.data.email,
                  firstName: dataRes.data.firstName,
                  isAdmin: isAdmin
              };
              // Store user data in Redux
              dispatch(setToken(userData));
              
              // Store in cookies and localStorage
              Cookies.set('token', dataRes.token, { expires: 30 });
              localStorage.setItem("token", dataRes.token);
              localStorage.setItem("email", dataRes.data.email);
              localStorage.setItem("firstName", dataRes.data.firstName);
              localStorage.setItem("isAdmin", isAdmin);

              setTimeout(() => {
                  navigate("/");
              }, 1000);
          }

      } catch (err) {
          console.error("Login error:", err);
          toast.error("Login failed! Please try again.");
      }
  }


  return (
    <div className='p-3 md:p-4'>
      <SEO title="Login - K Bakery" description="Login to your K Bakery account to order delicious cakes and manage your profile." />
      <div className='w-full max-w-sm bg-white m-auto flex flex-col p-4'>
         <h1 className='text-center text-2xl font-bold mb-4'>Login</h1>
          <div className='w-10 overflow-hidden rounded-full drop-shadow-md shadow-md m-auto flex items-center'>
              <img src={loginSignupImage} className='w-full' alt="login"/>
          </div>
          <form className="w-full py-3 flex flex-col" onSubmit={handleSubmit}>
              <label htmlFor="email" className='font-bold'>Email</label>
              <div className='flex px-2 py-1 bg-slate-200 rounded mt-1 mb-4 focus-within:outline focus-within:outline-purple-300'>
                  <input type="text" 
                         id="email" 
                         name="email" 
                         className="w-full bg-slate-200 border-none outline-none"
                         value={data.email} 
                         onChange={handleOnChange}/>
              </div>

              <label htmlFor="password" className='font-bold'>Password</label>
              <div className='flex px-2 py-1 bg-slate-200 rounded mt-1 mb-4 focus-within:outline focus-within:outline-purple-300'>
                  <input type={showPassword ? "text" : "password"} 
                         id="password" 
                         name="password" 
                         className="w-full bg-slate-200 border-none outline-none"
                         value={data.password} 
                         onChange={handleOnChange}/>
                  <span className='flex text-xl cursor-pointer' onClick={handleShowPassword}>
                      {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </span>
              </div>

              <button className='w-full max-w-[120px] m-auto bg-green-400 hover:bg-green-600 text-l font-bold py-1 rounded-full cursor-pointer text-center mt-2'>
                  Login
              </button>
          </form>
          <div className='flex justify-between mt-2'>
            <p className='text-sm'>
              <Link to="/forgot-password" className='text-blue-600 hover:underline'>Forgot Password?</Link>
            </p>
          </div>
          
          <div className="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5">
            <p className="text-center font-semibold mx-4 mb-0 text-sm">OR</p>
          </div>

          <div className="flex justify-center gap-4 mb-4">
            <GoogleLogin
               onSuccess={async (credentialResponse) => {
                 try {
                   const fetchData = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/google-login`, {
                     method: "POST",
                     headers: { "Content-Type": "application/json" },
                     body: JSON.stringify({ token: credentialResponse.credential })
                   });
                   const dataRes = await fetchData.json();
             
                   if (dataRes.alert && dataRes.token) {
                     toast.success('Successfully logged in with Google');
                     const userData = {
                       token: dataRes.token,
                       email: dataRes.data.email,
                       firstName: dataRes.data.firstName,
                       isAdmin: false,
                     };
                     dispatch(setToken(userData));
                     Cookies.set('token', dataRes.token, { expires: 30 });
                     localStorage.setItem("token", dataRes.token);
                     localStorage.setItem("email", dataRes.data.email);
                     localStorage.setItem("firstName", dataRes.data.firstName);
                     
                     setTimeout(() => navigate("/"), 1000);
                   } else {
                     toast.error(dataRes.message || "Google login failed");
                   }
                 } catch (err) {
                   toast.error('Could not login with Google');
                 }
               }}
               onError={() => {
                 toast.error('Google Login Failed');
               }}
            />

            <FacebookLogin
              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
              onSuccess={async (response) => {
                try {
                  const fetchData = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/facebook-login`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ accessToken: response.accessToken })
                  });
                  const dataRes = await fetchData.json();

                  if (dataRes.alert && dataRes.token) {
                    toast.success('Successfully logged in with Facebook');
                    const userData = {
                      token: dataRes.token,
                      email: dataRes.data.email,
                      firstName: dataRes.data.firstName,
                      isAdmin: false,
                    };
                    dispatch(setToken(userData));
                    Cookies.set('token', dataRes.token, { expires: 30 });
                    localStorage.setItem("token", dataRes.token);
                    localStorage.setItem("email", dataRes.data.email);
                    localStorage.setItem("firstName", dataRes.data.firstName);
                    
                    setTimeout(() => navigate("/"), 1000);
                  } else {
                    toast.error(dataRes.message || "Facebook login failed");
                  }
                } catch (err) {
                  toast.error('Could not login with Facebook');
                }
              }}
              onFail={(error) => {
                console.error('Facebook Login Failed', error);
                toast.error('Facebook Login Failed');
              }}
              render={({ onClick }) => (
                <button type="button" onClick={onClick} className="bg-blue-600 hover:bg-blue-700 text-white rounded p-2 h-10 flex items-center justify-center min-w-[40px]">
                  <FaFacebookF />
                </button>
              )}
            />
          </div>

          <p className='text-center mt-2'>
            Don't have an account? <u><Link to="/signup" className='text-red-700'>Sign Up</Link></u>
          </p>
      </div>
    </div>
  )
}

export default Login;
